export const downloadFile = /* istanbul ignore next */ (
  content: string,
  fileName: string,
) => {
  const linkSource =
    'data:application/octet-stream;base64,' + encodeURI(content);
  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};
